export default function monitorInputChange(eleId: string){
    let ele = document.getElementById(eleId);
    if (ele) {
      ele.style.borderColor = '#D9D9D9';
    }
}